import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import Iconify from "../../../components/Iconify";
import FrmAgregarEgreso from "./Forms/FrmAgregarEgreso";
const EgresosHead = ({
  setOpenDialog,
  setBodyDialog,
  setTitle,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const handleOpenDialog = () => {
    setTitle("Registrar egreso");
    setBodyDialog(
      <FrmAgregarEgreso
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
      />
    );
    setOpenDialog(true);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant="h4" gutterBottom>
        Gastos
      </Typography>
      <Button
        onClick={() => handleOpenDialog()}
        startIcon={<Iconify icon="eva:plus-fill" />}
      >
        Nuevo Registro
      </Button>
    </Stack>
  );
};

export default EgresosHead;
